// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1BxcD","textPadding":"styles_textPadding__1ywOo","bordered":"styles_bordered__h_RNj"};